import React from 'react'

import classnames from 'classnames/bind'
import css from './styles.module.scss'

const cx = classnames.bind(css)

const EmbedTweet = ({ className, html }) => {
  return (
    <blockquote
      className={cx(className, css.EmbedTweet)}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  )
}

EmbedTweet.defaultProps = {}

export default EmbedTweet
